<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="min(680px, calc(100vw - 32px))">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.materialSupplierId" class="title-actions">
        <el-button v-if="isAuth('base:materialSupplier:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('base:materialSupplier:delete')" type="primary" size="small" @click="remove">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px" @keyup.enter.native="readonly ? undefined : save()">
      <el-form-item label="主物料" prop="materialId">
        <el-select v-model="form.materialId" :disabled="readonly" style="width:100%" filterable>
          <el-option v-for="item in materials" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
        </el-select>
      </el-form-item>
      <el-form-item label="供应商" prop="supplierId">
        <el-input v-model="form.supplierName" readonly placeholder="请选择供应商">
          <el-button v-if="!readonly" slot="append" @click="supplierVisible = true">选择</el-button>
        </el-input>
      </el-form-item>
      <el-row :gutter="16">
        <el-col :xs="24" :sm="12"><el-form-item label="联系人" prop="personName"><el-input v-model="form.personName" :disabled="readonly" /></el-form-item></el-col>
        <el-col :xs="24" :sm="12"><el-form-item label="联系电话" prop="personTel"><el-input v-model="form.personTel" :disabled="readonly" /></el-form-item></el-col>
      </el-row>
      <el-form-item label="联系地址" prop="address"><el-input v-model="form.address" :disabled="readonly" /></el-form-item>
      <el-row :gutter="16">
        <el-col :xs="24" :sm="10">
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="form.sort" :disabled="readonly" :min="0" :step="1" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="7">
          <el-form-item label="主供应商">
            <el-switch v-model="mainSupplierSwitch" :disabled="readonly" active-color="#13ce66" inactive-color="#dcdfe6" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="7">
          <el-form-item label="打票供应商">
            <el-switch v-model="billSupplierSwitch" :disabled="readonly" active-color="#13ce66" inactive-color="#dcdfe6" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="remark"><el-input v-model="form.remark" :disabled="readonly" type="textarea" :rows="3" /></el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save()">确定</el-button>
    </span>
    <supplier-selector :visible.sync="supplierVisible" @select="onSupplier" />
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import SupplierSelector from '../../components/SupplierSelector.vue'

export default {
  components: { SupplierSelector },
  data() {
    return {
      visible: false, readonly: false, form: {}, materials: [], permCodes: [],
      mainSupplierSwitch: false, billSupplierSwitch: false, supplierVisible: false,
      rules: {
        materialId: [{ required: true, message: '主物料不能为空', trigger: 'change' }],
        supplierId: [{ required: true, message: '请选择供应商', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看物料供应商'
      return this.form.materialSupplierId ? '修改物料供应商' : '新增物料供应商'
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(row, readonly, materialId) {
      this.loadMaterials()
      this.readonly = !!readonly
      this.visible = true
      const blank = () => ({
        materialId: materialId || '',
        supplierId: '',
        supplierName: '',
        personName: '',
        personTel: '',
        address: '',
        sort: 0,
        isMainSupplier: '0',
        isBillSupplier: '0',
        remark: ''
      })
      const apply = data => {
        this.form = Object.assign(blank(), data || {}, { sort: (data && data.sort) || 0 })
        this.mainSupplierSwitch = this.form.isMainSupplier === '1'
        this.billSupplierSwitch = this.form.isBillSupplier === '1'
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }
      if (!row || !row.materialSupplierId) {
        apply(blank())
        return
      }
      request.get('/base/materialSupplier/info/' + row.materialSupplierId).then(res => apply(res.data || row)).catch(() => apply(row))
    },
    loadMaterials() {
      request.post('/base/material/page', { currentPage: 1, pageSize: 500 }).then(res => {
        this.materials = (res.data && res.data.list) || []
      }).catch(() => {})
    },
    onSupplier(row) {
      this.form.supplierId = row.supplierId
      this.form.supplierName = row.supplierName
      this.form.personName = row.contactPerson || row.personName || ''
      this.form.personTel = row.phone || row.personTel || ''
      this.form.address = row.address || ''
      this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.validateField('supplierId') })
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.form.isMainSupplier = this.mainSupplierSwitch ? '1' : '0'
        this.form.isBillSupplier = this.billSupplierSwitch ? '1' : '0'
        request.post('/base/materialSupplier/' + (this.form.materialSupplierId ? 'update' : 'save'), this.form).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    remove() {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        request.post('/base/materialSupplier/delete', { materialSupplierId: this.form.materialSupplierId }).then(() => {
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
</style>
